import { render } from "./LoadingPageDesktop.vue?vue&type=template&id=3e95cbba&ts=true"
import script from "./LoadingPageDesktop.vue?vue&type=script&lang=ts"
export * from "./LoadingPageDesktop.vue?vue&type=script&lang=ts"

import "./LoadingPageDesktop.vue?vue&type=style&index=0&id=3e95cbba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__